import axios from 'axios';
import { Fragment, useState } from 'react';
import { useDispatch } from 'react-redux';
import Table from '../Table/Table';
import Header from '../Admin/Dashboard/Header';
import baseApi from '../api';
import moment from 'moment/moment';
import { Link } from 'react-router-dom';
import ConfirmModal from '../ConfirmModal/ConfirmModal';

const CaseStudies = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsloading] = useState(false);
  const [itemTODelete, setItemToDelete] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleDelete = (id) => {
    setIsloading(true);
    let reqObj = {
      method: 'DELETE',
      url: `${baseApi}case-study/remove-case-study/${id}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`
      }
    };

    axios(reqObj)
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsloading(false);
      });
  };

  const columns = [
    {
      name: 'Title',
      selector: (row) => `${row.b_title}`,
      sortable: true,
      width: '330px',
      wrap: true
    },
    {
      name: 'Description',
      selector: (row) =>
        `${row.b_description
          .replace(/<[^>]+>/g, '')
          .replace('&nbsp;', ' ')
          .substring(0, 80)}...`,
      sortable: true,
      width: '330px',
      wrap: true
    },
    {
      name: 'Image',
      selector: (row) => <img style={{ width: '100px', height: '60px' }} src={row.image} />,
      sortable: false,
      width: '150px'
    },
    {
      name: 'Date',
      selector: (row) => moment(row.createdAt).format('DD MMM YYYY'),
      sortable: true,
      width: '140px'
    },
    {
      name: 'Action',
      width: '140px',
      cell: (row) => (
        <Fragment>
          <div>
            <div>
              <a
                href="#0"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setItemToDelete(row._id);
                  openModal();
                }}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
              &nbsp;&nbsp;&nbsp;
              <Link to={'/edit-case-study/' + row._id}>
                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
              </Link>
              &nbsp;&nbsp;&nbsp;
              <Link to={'/case-study/' + row.slug}>
                <i className="fa fa-eye" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </Fragment>
      )
    }
  ];
  const options = {
    title: 'Case Study',
    type: 'Case Study',
    columns: columns,
    apiUrl: `${baseApi}case-study/list-case-study-admin`,
    showAddBtn: true,
    AddBtnUrl: '/add-case-study'
  };

  return (
    <Fragment>
      <Header title="case study list">
        <Table options={options} isLoading={isLoading} />
        <ConfirmModal isOpen={modalOpen} onClose={closeModal} type={'Case Study'} content={'Are you sure you want to delete this case study?'} handleDelete={handleDelete} id={itemTODelete} />
      </Header>
    </Fragment>
  );
};

export default CaseStudies;
